import { Layout } from "antd";
import { SideBar } from "./sidebar";
import { routes as Routes } from "../../routes";
const { Sider, Content } = Layout;

export const Shell = () => {
  return (
    <div className="font-sans antialiased">
      <Layout>
        <Sider>
          <SideBar />
        </Sider>
        <Layout className="bg-white">
          <Content>
            <Routes />
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};
